import gp from "assets/images/banners/pediaInternal/genralpediatric.jpg";
import ps from "assets/images/banners/pediaInternal/pediatricsurgery.jpg";
import pni from "assets/images/banners/pediaInternal/pediatricneutrition.jpg";
import cp from "assets/images/banners/pediaInternal/childpsycology.jpg";
import cn from "assets/images/banners/pediaInternal/childrehabitation.jpg";
import pn from "assets/images/banners/pediaInternal/pediatricneutrition.jpg";

import gpI from "assets/images/banners/pediaInternalBanner/gp.png";
import psI from "assets/images/banners/pediaInternalBanner/ps.png";
import pniI from "assets/images/banners/pediaInternalBanner/pni.png";
import cpI from "assets/images/banners/pediaInternalBanner/cp.png";
import cnI from "assets/images/banners/pediaInternalBanner/cn.png";
import pnI from "assets/images/banners/pediaInternalBanner/pn.png";

export const list = [
  {
    id: "generalPaediatrics",
    label: "General Paediatrics",
    content: "datamap",
  },
  {
    id: "paediatricsSurgery",
    label: "Paediatrics Surgery",
    content: "datamap",
  },
  {
    id: "paediatricsAndNeonatalICU",
    label: "Paediatrics and Neonatal ICU",
    content: "datamap",
  },
  {
    id: "childPsychology",
    label: "Child Psychology",
    content: "datamap",
  },
  {
    id: "childRehabilitation",
    label: "Child Rehabilitation",
    content: "datamap",
  },
  {
    id: "paediatricsNutrition",
    label: "Paediatrics Nutrition",
    content: "datamap",
  },
];

export const internalData = [
  {
    id: "generalPaediatrics",
    label: "General Paediatrics",
    img: gp,
    banner: gpI,
    data: [
      {
        header: "What is General Paediatrics?",
        content:
          "General Paediatrics focuses on the overall health of children, providing essential care from birth through adolescence. This includes routine health check-ups, vaccinations, and the management of common and complex illnesses.",
        points: null,
      },
      {
        header: "Who Can Benefit from General Paediatrics?",
        content:
          "General Paediatrics is beneficial for all children, from newborns to teenagers, who need regular health evaluations or have specific health concerns. Consider our services if:",
        points: [
          "Your child requires routine health check-ups and vaccinations.",
          "You need management for chronic conditions or acute illnesses.",
          "You are seeking expert advice on your child's growth and development.",
          "You want a trusted partner in your child’s ongoing health care journey.",
        ],
      },
      {
        header: "Key Services in General Paediatrics",
        content:
          "We offer a range of essential services in General Paediatrics to keep your child healthy and thriving.",
        points: [
          "Health Monitoring: Regular evaluations of overall health and development.",
          "Vaccinations: Immunizations to protect against diseases.",
          "Illness Management: Care for acute and chronic conditions.",
          "Growth Tracking: Guidance for healthy development.",
        ],
      },
      {
        header: "How We Provide Comprehensive Paediatric Care",
        content:
          "Our approach to General Paediatrics involves thorough assessments and tailored care plans to address each child’s unique needs.",
        points: [
          "Holistic Care: Addressing physical, emotional, and developmental needs.",
          "Experienced Team: Paediatricians with extensive training.",
          "Personalized Care Plans: Customized strategies to meet your child’s specific needs.",
        ],
      },
    ],
  },
  {
    id: "paediatricsSurgery",
    label: "Paediatrics Surgery",
    img: ps,
    banner: psI,

    data: [
      {
        header: "What is Paediatric Surgery?",
        content:
          "Paediatric Surgery involves specialized surgical procedures designed to address a variety of conditions in children, from congenital abnormalities to acquired conditions. These surgeries are performed with a focus on the unique needs of growing children.",
        points: null,
      },
      {
        header: "Is Paediatric Surgery Right for Your Child?",
        content:
          "Paediatric Surgery is ideal for children who require surgical intervention for conditions that cannot be managed through non-surgical treatments. It is particularly suitable if your child:",
        points: [
          "Has a Congenital Condition: Such as heart defects or cleft palate.",
          "Experiences Persistent Symptoms: That impact their quality of life.",
          "Requires Specialized Care: For conditions unique to their developmental stage.",
        ],
      },
      {
        header: "What Types of Paediatric Surgeries Are Available?",
        content:
          "Paediatric surgery includes various specialized procedures tailored to treat different conditions:",
        points: [
          "Congenital Heart Surgery: Corrects birth defects to improve heart function.",
          "Cleft Lip and Palate Repair: Enhances speech, appearance, and feeding.",
          "Appendectomy: Removes the appendix for appendicitis.",
          "Hernia Repair: Treats painful or complicated hernias.",
          "Paediatric Urological Surgery: Addresses undescended testicles and urinary tract issues.",
          "Neonatal Surgery: Treats critical conditions in newborns like intestinal obstructions.",
        ],
      },
      {
        header: "How are Paediatric Surgeries Performed?",
        content:
          "Paediatric surgery employs techniques that are adapted to the smaller anatomy and specific needs of children:",
        points: [
          "Minimally Invasive: Small incisions for quicker recovery and less scarring.",
          "Advanced Imaging: Precise surgical planning with cutting-edge technology.",
          "Child-Centered: Compassionate care for physical and emotional needs.",
          "Expert Surgeons: Skilled in safe, effective techniques for optimal outcomes.",
        ],
      },
    ],
  },
  {
    id: "paediatricsAndNeonatalICU",
    label: "Paediatrics and Neonatal ICU",
    img: pni,
    banner: pniI,
    data: [
      {
        header: "What is Paediatric and Neonatal ICU?",
        content:
          "The Paediatric and Neonatal ICU provides specialized, intensive care for critically ill infants, children, and newborns. Our ICU is designed to manage complex conditions and offer life-saving interventions.",
        points: null,
      },
      {
        header: "Is Paediatric and Neonatal ICU Right for Your Child?",
        content:
          "Our Paediatric and Neonatal ICU is ideal for infants and children who require intensive monitoring and specialized care. It is ideal if the child needs:",
        points: [
          "Critical Care: Severe respiratory distress, complex congenital issues, surgery recovery.",
          "Specialized Monitoring: Continuous observation and advanced interventions.",
          "Acute Illnesses: Serious infections, trauma, or complications needing immediate care.",
        ],
      },
      {
        header:
          "What Types of Care Are Provided in Paediatric and Neonatal ICU?",
        content:
          "Our Paediatric and Neonatal ICU offers a range of critical care services tailored to the needs of young patients:",
        points: [
          "Respiratory Support: Mechanical ventilation, CPAP.",
          "Cardiac Care: Monitoring and treatment for heart conditions.",
          "Neonatal Care: For premature infants or critical conditions.",
          "Post-Surgical Care: Intensive support for surgery recovery.",
          "Neurological Care: Advanced interventions for severe conditions.",
          "Nutritional Support: Tailored feeding plans and IV nutrition.",
        ],
      },
      {
        header: "How is Paediatric and Neonatal Care Provided?",
        content:
          "Care in our Paediatric and Neonatal ICU is delivered through advanced techniques and technology:",
        points: [
          "Advanced Monitoring: Continuous assessment of vital signs.",
          "Specialized Interventions: Customized respiratory, cardiac, and neurological care.",
          "Multidisciplinary Teams: Comprehensive care by Paediatricians, neonatologists, surgeons, and specialists.",
          "Family Support: Counseling and involvement in care plans.",
        ],
      },
    ],
  },
  {
    id: "childPsychology",
    label: "Child Psychology",
    img: cp,
    banner: cpI,
    data: [
      {
        header: "Understanding Child Psychology",
        content:
          "Child Psychology focuses on understanding and addressing the mental, emotional, and behavioral issues that children may experience. We use evidence-based approaches to help children navigate challenges and achieve their full potential.",
        points: null,
      },
      {
        header: "When To Get Child Psychology Services",
        content:
          "Child Psychology is ideal for children experiencing emotional or behavioral difficulties. It is particularly suitable if your child:",
        points: [
          "Struggles with Emotional Issues",
          "Displays Behavioral Problems",
          "Faces Developmental Challenges",
          "Requires Support Through Transitions",
        ],
      },
      {
        header: "What Types of Child Psychology Services Are Available?",
        content:
          "Our Child Psychology services cover a wide range of therapeutic interventions and support:",
        points: [
          "Individual Therapy: Personalized sessions to address behavioral issues.",
          "Play Therapy: Uses play to help children express feelings.",
          "Family Therapy: Involves family members to improve communication.",
          "Cognitive-Behavioral Therapy (CBT): Helps children develop healthier behaviors.",
          "Developmental Assessments: Evaluates cognitive and emotional development.",
          "Crisis Intervention: Immediate support for children experiencing acute distress.",
        ],
      },
      {
        header: "How Is Child Psychology Provided?",
        content:
          "Child Psychology services are delivered through a variety of approaches tailored to each child’s needs:",
        points: [
          "Comprehensive Assessments: Conduct thorough evaluations.",
          "Evidence-Based Therapies: Utilize therapeutic techniques to address behavioral issues.",
          "Collaborative Approach: Work closely with parents to support child’s well-being.",
          "Supportive Environment: Create a safe and nurturing space where children feel comfortable.",
        ],
      },
    ],
  },
  {
    id: "childRehabilitation",
    label: "Child Rehabilitation",
    img: cn,
    banner: cnI,
    data: [
      {
        header: "What is Child Rehabilitation?",
        content:
          "Child Rehabilitation focuses on helping children recover from injuries, surgeries, or illnesses by promoting physical, cognitive, and emotional development.",
        points: null,
      },
      {
        header: "Who Benefits from Child Rehabilitation Services",
        content:
          "Child Rehabilitation is beneficial for children who need support in recovering from various physical or developmental challenges. It is particularly suitable if your child:",
        points: [
          "Has Recently Had an Injury or Surgery",
          "Is Experiencing Developmental Delays",
          "Has a Chronic Condition",
          "Faces Cognitive or Behavioral Challenges",
        ],
      },
      {
        header: "What Types of Child Rehabilitation Services Are Available?",
        content:
          "Our Child Rehabilitation services encompass a range of specialized therapies:",
        points: [
          "Physical Therapy: Focuses on improving motor skills and coordination.",
          "Occupational Therapy: Helps children develop skills for daily living.",
          "Speech Therapy: Addresses communication and language challenges.",
          "Cognitive Rehabilitation: Supports children with cognitive impairments.",
          "Behavioral Therapy: Assists in managing and modifying challenging behaviors.",
          "Developmental Therapy: Aims to support developmental milestones.",
        ],
      },
      {
        header: "How Is Child Rehabilitation Provided?",
        content:
          "Child Rehabilitation involves various therapeutic approaches tailored to each child’s specific needs:",
        points: [
          "Comprehensive Assessments",
          "Evidence-Based Therapies",
          "Family-Centered Care",
          "Progress Monitoring",
        ],
      },
    ],
  },
  {
    id: "paediatricsNutrition",
    label: "Paediatrics Nutrition",
    img: pn,
    banner: pnI,
    data: [
      {
        header: "What is Paediatric Nutrition?",
        content:
          "Paediatric Nutrition focuses on providing expert dietary guidance to support your child’s growth, development, and overall health. It involves creating balanced and age-appropriate nutritional plans for your child.",
        points: null,
      },
      {
        header: "Who Benefits from Paediatric Nutrition",
        content:
          "Paediatric Nutrition is beneficial for children of all ages who require specialized dietary support. It is particularly important if your child:",
        points: [
          "Has Specific Dietary Needs",
          "Is Experiencing Growth Issues",
          "Is a Picky Eater",
          "Requires Support for Healthy Habits",
        ],
      },
      {
        header: "What Types of Paediatric Nutrition Services Are Available?",
        content:
          "Our Paediatric Nutrition services include a range of specialized support:",
        points: [
          "Personalized Meal Planning",
          "Nutritional Counseling",
          "Allergy and Intolerance Management",
          "Growth and Development Tracking",
          "Education and Support",
        ],
      },
      {
        header: "How Is Paediatric Nutrition Services Delivered?",
        content:
          "Paediatric Nutrition services involve a comprehensive approach to dietary management:",
        points: [
          "Initial Assessment: Evaluating your child’s current nutritional status.",
          "Customized Planning: Designing a tailored nutrition plan.",
          "Ongoing Monitoring: Regular follow-ups to assess progress.",
          "Family Involvement: Engaging with parents to ensure dietary changes are sustainable.",
        ],
      },
    ],
  },
];

export const listheader = "Our Paediatrics Services";

export const pediatricsInternal = { list, internalData, listheader };
